<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter #gridFilter placeholder="Type '/' to bring up a list of available filters, or type a number, name, tag to filter"
                   (selectedItemsChanged)="onSelectedItemsChanged($event)"
                   [selectedItemsChange]="selectedFilterChange"
                   [disableUrlChanges]="disableUrlChanges"
                   [initialQuery]="customContactsQuery"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)"
                   [showFilterButton]="true" (onFilterButtonClicked)="openFilterDialog()">
    <app-filter-row-additional-content fxFlex="auto" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
      <button mat-raised-button color="primary" matTooltip="Add new contact" *ngIf="hasEditAccess && !readonly"
              (click)="navigateToDetails()">
        + Add
      </button>
      <button mat-stroked-button color="primary" matTooltip="Edit selected contacts in bulk" *ngIf="hasEditAccess && !readonly"
              (click)="onBulkEditClick()">
        Edit Selected
      </button>
    </app-filter-row-additional-content>
    <app-filter-second-row-additional-content *ngIf="!readonly">
      <ng-container *ngFor="let item of duplicateSummary">
        <a (click)="openDuplicatesList($event, item.recordType)" style="padding-left: 10px; font-size: 13px; display: inline-block; cursor: pointer; text-decoration: underline">
          {{item.total}} duplicates in {{item.recordType == '1' ? 'Private' : 'Public'}} Directory
        </a><span class="text-warn" style="padding-left: 5px; font-size: 13px">Duplicate contacts may result in incorrect search results.</span><br>
      </ng-container>
    </app-filter-second-row-additional-content>
  </app-grid-filter>

  <div fxFlex class="stretched-container">
    <app-contacts-grid #contactsGrid [readonly]="readonly" [filterChangeEvent]="filterChangeEvent"></app-contacts-grid>
  </div>
</div>
